import cloudy from '../../assets/images/weather/couldy.gif';
import sunny from '../../assets/images/weather/sunny.gif';
import windy from '../../assets/images/weather/windy.gif';
import couldySun from '../../assets/images/weather/couldySun.gif';
import raining from '../../assets/images/gifs/raining.gif';
import bmoFace from '../../assets/images/bmo-face/Rosto-09.png';

import bmo1 from '../../assets/images/bmo-face/Rosto-01.png';
import bmo2 from '../../assets/images/bmo-face/Rosto-02.png';
import bmo3 from '../../assets/images/bmo-face/Rosto-03.png';
import bmo4 from '../../assets/images/bmo-face/Rosto-04.png';
import bmo5 from '../../assets/images/bmo-face/Rosto-05.png';
import bmo6 from '../../assets/images/bmo-face/Rosto-06.png';
import bmo7 from '../../assets/images/bmo-face/Rosto-07.png';
import bmo8 from '../../assets/images/bmo-face/Rosto-08.png';
import bmo9 from '../../assets/images/bmo-face/Rosto-09.png';
import bmo12 from '../../assets/images/bmo-face/Rosto-12.png';
import bmo14 from '../../assets/images/bmo-face/Rosto-14.png';
import bmo16 from '../../assets/images/bmo-face/Rosto-16.png';
import bmo17 from '../../assets/images/bmo-face/Rosto-17.png';
import bmo18 from '../../assets/images/bmo-face/Rosto-18.png';

import bmo22 from '../../assets/images/bmo-face/Rosto-22.png';
import bmo24 from '../../assets/images/bmo-face/Rosto-24.png';

export type WeatherType = | 'Thunderstorm'| 'Drizzle'| 'Rain'| 'Snow'| 'Mist'| 'Smoke'| 'Haze'| 'Dust'| 'Fog'| 'Sand'| 'Ash'| 'Squall'| 'Tornado'| 'Clear'| 'Clouds';

class BmoFace {
    private static instance: BmoFace;
    private default_faces = [bmo8, bmo18, bmo14, bmo18]
    private sunny_images = [bmo1, bmo2, bmo5, sunny];
    private raining_images = [bmo3, bmo6, bmo12, raining];
    private cloudy_images = [bmo9, bmo16, bmo24, cloudy];
    private windy_images = [bmo17, bmo22, bmo24, windy];
    private constructor() {
    }

    public static getInstance(): BmoFace {
        if (!BmoFace.instance) {
            BmoFace.instance = new BmoFace();
        }
        return BmoFace.instance;
    }

    public getWeather(weather: WeatherType): string[] {
        switch (weather) {
            case 'Clear':
                return this.sunny_images;
            case 'Clouds':
                return this.cloudy_images;
            case 'Haze':
            case 'Tornado':
                return this.windy_images;
            case 'Drizzle':
            case 'Rain':
                return this.raining_images;
            default:
                return this.default_faces; // or a default image
        }
    }
}

export default BmoFace;